import { Button as _Button } from 'antd';
import styled from 'styled-components';

export const StyledButton = styled(_Button)`
  &.ant-btn > .ant-btn-icon + span {
    margin-left: 8px;
  }
`;
